<template>
    <p>WorkSpace for User</p>
</template>

<script>

    export default {
        name: "main",
        components: {
        }
    }
</script>

<style scoped>

</style>